module.exports = __webpack_public_path__ + "static/media/still.05ebb44a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/DevicePreview/still.png
// module id = 1511
// module chunks = 0